"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require("../AbstractReactComponent");

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _SpisovaSluzbaApi = require("./../api/gen/spisovaSluzba/SpisovaSluzbaApi");

var _SpisovaSluzbaApi2 = _interopRequireDefault(_SpisovaSluzbaApi);

var _ObjectSuggestField = require("./ObjectSuggestField");

var _ObjectSuggestField2 = _interopRequireDefault(_ObjectSuggestField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field pro výběr kategorie úřední desky.
 */
/**
 * Komponenta fulltextového hledání kategorie úřední desky - našeptávač.
 */
var KategorieUredniDeskyField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(KategorieUredniDeskyField, _AbstractReactCompone);

    function KategorieUredniDeskyField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, KategorieUredniDeskyField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = KategorieUredniDeskyField.__proto__ || (0, _getPrototypeOf2.default)(KategorieUredniDeskyField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            list: null
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(KategorieUredniDeskyField, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            this.setState({ list: null });
            _SpisovaSluzbaApi2.default.getKategorieUredniDesky().then(function (list) {
                _this2.setState({ list: list });
            });
        }
    }, {
        key: "render",
        value: function render() {
            var list = this.state.list;
            var otherProps = (0, _objectWithoutProperties3.default)(this.props, []);


            return _react2.default.createElement(_ObjectSuggestField2.default, (0, _extends3.default)({
                dropdown: true,
                removable: false,
                items: list,
                itemValueAttrName: "nazev"
            }, otherProps));
        }
    }]);
    return KategorieUredniDeskyField;
}(_AbstractReactComponent2.default);

exports.default = KategorieUredniDeskyField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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